__webpack_require__.p = "/web-terms/_next/";